import React from 'react';
import classnames from 'classnames';
import { useSelector } from 'react-redux';

import { DefaultDogTagComponentsData } from '~/interfaces';
import { State } from '~/Reducers';
import { ComponentIcons, DogTagComponent } from '~/vortex';

import styles from './DogTagBackground.scss';

interface DogTagBackgroundProps {
    doll: DogTagComponent;
    className?: string;
    size?: 'extraLarge';
}

const stateSelector = (state: State): DefaultDogTagComponentsData => {
    return state.ReducerApp.response.defaultDogTagComponents;
};

function getImage(icons: ComponentIcons, size?: DogTagBackgroundProps['size']) {
    if (size === 'extraLarge') return icons.large;
    return icons.small;
}

export default function DogTagBackground(props: DogTagBackgroundProps) {
    const defaultDogTagComponents = useSelector<State, DefaultDogTagComponentsData>(stateSelector);
    const { doll } = props;

    const isColorizable = doll.isColorizable;
    let backgroundImage = getImage(doll.icons, props.size);
    let borderImage = '';
    const backgroundColor = (isColorizable && defaultDogTagComponents.backgroundColor?.replace('0x', '#')) || '';
    const borderColor = (isColorizable && defaultDogTagComponents.borderColor?.replace('0x', '#')) || '';
    if (isColorizable) {
        const textureData = defaultDogTagComponents.textureData.find((texData) => texData.id == doll.id);
        backgroundImage = getImage(textureData.background, props.size);
        borderImage = getImage(textureData.border, props.size);
    }

    return (
        <div className={classnames(styles.wrapper, props.className, props.size)}>
            {backgroundImage && (
                <div
                    className={classnames(styles.background, styles.component, isColorizable && styles.colorizable)}
                    style={
                        {
                            '--image': `url('${backgroundImage}')`,
                            backgroundColor: backgroundColor,
                        } as React.CSSProperties
                    }
                >
                    <div className={styles.image} />
                </div>
            )}
            {borderImage && (
                <div
                    className={classnames(styles.border, styles.component, isColorizable && styles.colorizable)}
                    style={
                        {
                            '--image': `url('${borderImage}')`,
                            backgroundColor: borderColor,
                        } as React.CSSProperties
                    }
                >
                    <div className={styles.image} />
                </div>
            )}
        </div>
    );
}
